import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { FormFields } from '../../AccountForm.meta';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const Donor = () => {
  const formBag = useFormContext<FormFields>();

  const {
    options: {
      OwnerOptions: { People },
    },
  } = useAccountFormContext();

  const donorOptions = People.map(label => ({
    label,
    value: label,
  }));

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.AccountOwner"
      render={({ field }) => {
        return <Select {...field} isPortal options={donorOptions} label="Donor" />;
      }}
    />
  );
};
